const MAC = 'mac';
const LINUX = 'linux';
const WIN = 'win';
export class OsUtil {
  static _INSTANCE: OsUtil;

  OsName: string = '';
  isMacOs: boolean = false;
  isWindowsOs: boolean = false;
  isLinuxOs: boolean = false;

  constructor() {
    const os = navigator.platform;
    if (os) {
      const platform = os.toLowerCase();
      if (platform.includes(MAC)) this.isMacOs = true;
      else if (platform.includes(WIN)) this.isWindowsOs = true;
      else this.isLinuxOs = true;
    }
  }

  static isMAC() {
    return this.getInstance().isMacOs;
  }

  static isWindows() {
    return this.getInstance().isWindowsOs;
  }

  static isLinux() {
    return this.getInstance().isLinuxOs;
  }

  static getInstance() {
    return OsUtil._INSTANCE;
  }
}

OsUtil._INSTANCE = new OsUtil();
